import { LoginProduct } from '../../../../frontend/src/app/core/auth/user';
import { UserClerk } from '../../../../frontend/src/app/core/user/user-clerk';
import { BasicAction } from '../basic-action';
import { CountResponse, GetByEmailRequest, SuccessResponse } from '../request-response';
import { ResourceName } from '../resource-name';

// tslint:disable: variable-name
export const UserClerkGate = {
  resource: ResourceName.userClerk,
  actions: {
    getMy: BasicAction.getMy,
    getByEmail: 'get-by-email',
    getUserListByEmailList: 'get-user-list-by-email-list',
    updateMy: BasicAction.updateMy,

    isAccessTokenValid: 'is-access-token-valid',

    getUserCount: 'get-user-count',
    grantGooglePermission: 'grant-google-permission',

    getSignInTokens: 'get-sign-in-tokens',
  },
};

export type UserClerkGateActionTypes = {
  getMy: {
    request: undefined;
    response: any;
  };
  getByEmail: {
    request: GetByEmailRequest;
    response: any;
  };
  getUserListByEmailList: {
    request: GetUserListByEmailListRequest;
    response: UserClerk[];
  };
  updateMy: {
    request: any;
    response: any;
  };
  isAccessTokenValid: {
    request: undefined;
    response: any;
  };
  getUserCount: {
    request: GetByEmailRequest;
    response: CountResponse;
  };
  grantGooglePermission: {
    request: GrantGooglePermissionRequest;
    response: SuccessResponse;
  };

  getSignInTokens: {
    request: undefined;
    response: undefined;
  };
};

export interface GetUserListByEmailListRequest {
  emailList: string[];
}

export interface GrantGooglePermissionRequest {
  loginProduct: LoginProduct;
}

export interface UnlinkAccountRequest {
  primaryUserId: string;
  provider: string;
  secondaryUserId: string | number;
}
